import { render, staticRenderFns } from "./Template6.vue?vue&type=template&id=7aea1b40&scoped=true&"
import script from "./Template6.vue?vue&type=script&lang=js&"
export * from "./Template6.vue?vue&type=script&lang=js&"
import style0 from "./Template6.vue?vue&type=style&index=0&id=7aea1b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aea1b40",
  null
  
)

export default component.exports